import { useContext } from "react";
import { BillingContext } from "../contexts/billing-context";

const useBilling = () => useContext(BillingContext);


export default useBilling;